
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  DesignFlatButtonModule,
  DesignStrokedButton
} from '@simlab/design/button';
import { DesignDialogWrapperModule } from '@simlab/design/dialog';
import { DesignIcon } from '@simlab/design/icon';
import { ConfirmationModalRef } from '@simlab/ui/modal';
@Component({
  templateUrl: './new-update-modal.component.html',
  styleUrls: ['./new-update-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DesignDialogWrapperModule,
    DesignFlatButtonModule,
    DesignStrokedButton,
    DesignIcon
]
})
export class NewUpdateModalComponent {
  private readonly _modalRef = inject<ConfirmationModalRef<boolean>>(
    ConfirmationModalRef<boolean>
  );

  confirm(): void {
    this._modalRef.emit({ state: true });
    this._modalRef.close();
  }

  cancel(): void {
    this._modalRef.emit({ state: false });
    this._modalRef.close();
  }
}
